<script lang="ts">
  import { api } from "$lib/api/client";
  import { toasts } from "$lib/stores/toasts.svelte";

  let open = $state(false);
  let sending = $state(false);
  let message = $state("");
  let category = $state("bug");
  let screenshotBase64 = $state<string | null>(null);
  let screenshotName = $state("");
  let fileError = $state("");

  function handleFile(e: Event) {
    fileError = "";
    const file = (e.target as HTMLInputElement).files?.[0];
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) {
      fileError = "Imagem muito grande (máx. 5 MB).";
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result as string;
      // Remove o prefixo data:image/...;base64,
      screenshotBase64 = result.split(",")[1] ?? result;
      screenshotName = file.name;
    };
    reader.readAsDataURL(file);
  }

  async function submit() {
    if (!message.trim()) return;
    sending = true;
    try {
      await api("/feedback", {
        method: "POST",
        body: JSON.stringify({
          message: message.trim(),
          category,
          screenshot_base64: screenshotBase64,
          url: window.location.pathname,
        }),
      });
      toasts.success("Feedback enviado! Obrigado 🙏");
      open = false;
      message = "";
      screenshotBase64 = null;
      screenshotName = "";
    } catch {
      toasts.error("Erro ao enviar feedback. Tente novamente.");
    } finally {
      sending = false;
    }
  }

  function close() {
    open = false;
  }
</script>

<!-- Botão flutuante -->
{#if !open}
  <button
    onclick={() => (open = true)}
    class="fixed bottom-20 right-4 z-50 w-11 h-11 rounded-full bg-indigo-600 text-white shadow-lg
           flex items-center justify-center text-lg hover:bg-indigo-700 active:scale-95 transition-all"
    title="Relatar problema ou enviar feedback"
    aria-label="Feedback"
  >
    💬
  </button>
{/if}

<!-- Modal -->
{#if open}
  <!-- Overlay -->
  <div
    role="dialog"
    aria-modal="true"
    aria-label="Enviar feedback"
    class="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-4"
  >
    <!-- Backdrop -->
    <button
      type="button"
      class="absolute inset-0 bg-black/40"
      onclick={close}
      aria-label="Fechar"
    ></button>

    <!-- Card -->
    <div class="relative w-full max-w-md bg-white rounded-2xl shadow-2xl p-5 space-y-4">
      <div class="flex items-center justify-between">
        <h2 class="font-semibold text-base text-slate-800">Relatar problema / Feedback</h2>
        <button onclick={close} class="text-slate-400 hover:text-slate-600 text-xl leading-none" aria-label="Fechar">×</button>
      </div>

      <!-- Categoria -->
      <div class="flex gap-2 text-sm">
        {#each [["bug","🐛 Bug"],["sugestao","💡 Sugestão"],["elogio","⭐ Elogio"],["outro","📝 Outro"]] as [val, label]}
          <button
            type="button"
            onclick={() => (category = val)}
            class="flex-1 rounded-lg border py-1.5 text-xs font-medium transition-colors
                   {category === val ? 'bg-indigo-600 text-white border-indigo-600' : 'border-slate-200 text-slate-600 hover:border-indigo-300'}"
          >{label}</button>
        {/each}
      </div>

      <!-- Mensagem -->
      <div>
        <label for="fb-message" class="block text-xs font-medium text-slate-600 mb-1">
          Descreva o problema ou sugestão
        </label>
        <textarea
          id="fb-message"
          bind:value={message}
          rows={4}
          placeholder="Ex: Ao adicionar conta recorrente, ela não aparece nos meses seguintes..."
          class="w-full rounded-xl border border-slate-200 px-3 py-2 text-sm focus:outline-none
                 focus:ring-2 focus:ring-indigo-400 resize-none"
        ></textarea>
      </div>

      <!-- Screenshot -->
      <div>
        <label class="block text-xs font-medium text-slate-600 mb-1">
          Print da tela (opcional)
        </label>
        {#if screenshotName}
          <div class="flex items-center gap-2 text-xs text-slate-600 bg-slate-50 rounded-lg px-3 py-2">
            <span>🖼️ {screenshotName}</span>
            <button
              type="button"
              onclick={() => { screenshotBase64 = null; screenshotName = ""; }}
              class="ml-auto text-red-400 hover:text-red-600"
            >✕</button>
          </div>
        {:else}
          <label
            class="flex items-center gap-2 cursor-pointer rounded-xl border-2 border-dashed border-slate-200
                   px-3 py-3 text-sm text-slate-500 hover:border-indigo-300 hover:text-indigo-600 transition-colors"
          >
            <span>📎 Anexar print</span>
            <input
              type="file"
              accept="image/*"
              class="sr-only"
              onchange={handleFile}
            />
          </label>
        {/if}
        {#if fileError}
          <p class="text-xs text-red-500 mt-1">{fileError}</p>
        {/if}
      </div>

      <!-- Ações -->
      <div class="flex gap-2 pt-1">
        <button
          type="button"
          onclick={close}
          class="flex-1 rounded-xl border border-slate-200 py-2.5 text-sm font-medium text-slate-600 hover:bg-slate-50"
        >Cancelar</button>
        <button
          type="button"
          onclick={submit}
          disabled={sending || !message.trim()}
          class="flex-1 rounded-xl bg-indigo-600 py-2.5 text-sm font-medium text-white
                 hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {sending ? "Enviando…" : "Enviar"}
        </button>
      </div>
    </div>
  </div>
{/if}
